export class DonateDebounce {
    static openLink(cb: () => void) {
        const lastOpened = localStorage.getItem('donateDebounce')
        // only open once every 1 day
        if (lastOpened && Date.now() - parseInt(lastOpened) < 1000 * 60 * 60 * 24 * 1) {
            return false
        }
        localStorage.setItem('donateDebounce', Date.now().toString())
        cb()
        return true
    }

    static clicked() {
        localStorage.setItem('donateDebounce', Date.now().toString())
    }
}